import api from './api';

export const generateReport = async (reportType, filters) => {
  try {
    const response = await api.post('/reports/generate', {
      report_type: reportType,
      filters: filters
    });
    return response.data;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error;
  }
};

export const saveReport = async (title, description, reportType, filters) => {
  try {
    const response = await api.post('/reports', {
      title,
      description,
      report_type: reportType,
      filters
    });
    return response.data;
  } catch (error) {
    console.error('Error saving report:', error);
    throw error;
  }
};

export const getReports = async () => {
  try {
    const response = await api.get('/reports');
    return response.data;
  } catch (error) {
    console.error('Error fetching reports:', error);
    throw error;
  }
};

export const getReport = async (reportId) => {
  try {
    const response = await api.get(`/reports/${reportId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching report:', error);
    throw error;
  }
};

export const updateReport = async (reportId, updateData) => {
  try {
    const response = await api.put(`/reports/${reportId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating report:', error);
    throw error;
  }
};

export const deleteReport = async (reportId) => {
  try {
    const response = await api.delete(`/reports/${reportId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting report:', error);
    throw error;
  }
};